import RouteView from '@/router/RouteView.vue';
import ClassManage from './index.vue';
import Detail from "./Detail.vue";

export default [
  {
    path: '/classmanage',
    name: 'ClassManage',
    component: RouteView,
    redirect: '/classmanage/list',
    meta: {
      title: '班级管理'
    },
    children: [
      {
        path: '/classmanage/list',
        name: 'ClassManageList',
        component: ClassManage,
        meta: {
          title: '班级列表'
        },
      },
      {
        path: '/classmanage/detail/:id',
        name: 'ClassDetail',
        component: Detail,
        meta: {
          title: '班级详情'
        },
      }
    ]
  }
];




// WEBPACK FOOTER //
// ./src/views/ClassManage/index.js